document.addEventListener('DOMContentLoaded', () => {
    // Load variant data
    const variantsDataElement = document.getElementById('cart-drawer-variants-data');
    const variantsData = variantsDataElement ? JSON.parse(variantsDataElement.textContent) : { products: {} };

    // Update cart item description
    const updateCartItemDescription = (cartItem, usage, productHandle) => {
        const descriptionElement = cartItem.querySelector('.custom-cart-drawer-item-description');
        if (!descriptionElement) return;

        // Find the hidden description element for this product
        const productDescriptionElement = cartItem.querySelector(`.cart-product-description[data-product-handle="${productHandle}"][data-usage="${usage}"]`);

        if (productDescriptionElement) {
            // Use the metafield description
            descriptionElement.innerHTML = productDescriptionElement.innerHTML;
        } else {
            // Clear description if none found
            descriptionElement.innerHTML = '';
        }
    };

    // Get price from a cart item (product or variant)
    const getCartItemPrice = (cartItem) => {
        const formulaSelect = cartItem.querySelector('.cart-drawer-formula-select');
        if (!formulaSelect || !formulaSelect.value) return 0;

        const selectedOption = formulaSelect.querySelector(`option[value="${formulaSelect.value}"]`);
        if (!selectedOption) return 0;

        const hasVariants = selectedOption.getAttribute('data-has-variants') === 'true';
        
        // If product has variants, get variant price
        if (hasVariants) {
            const variantSelect = cartItem.querySelector('.cart-drawer-variant-select');
            if (variantSelect && variantSelect.value) {
                const selectedVariantOption = variantSelect.querySelector(`option[value="${variantSelect.value}"]`);
                if (selectedVariantOption) {
                    const variantPrice = selectedVariantOption.getAttribute('data-price');
                    if (variantPrice) {
                        // Extract numeric value from price string (e.g., "$169.00" -> 16900)
                        return parsePrice(variantPrice);
                    }
                }
            }
        }

        // Otherwise, get product price from the option's data attribute
        const productPrice = selectedOption.getAttribute('data-product-price');
        if (productPrice) {
            return parsePrice(productPrice);
        }

        return 0;
    };

    // Parse price string to cents (e.g., "$169.00" -> 16900)
    const parsePrice = (priceString) => {
        if (!priceString) return 0;
        // Remove currency symbols and spaces, then convert to number
        const numericString = priceString.replace(/[^0-9.]/g, '');
        const price = parseFloat(numericString);
        return isNaN(price) ? 0 : Math.round(price * 100); // Convert to cents
    };

    // Format price from cents to display format (e.g., 16900 -> "$169.00")
    const formatPrice = (cents) => {
        const dollars = (cents / 100).toFixed(2);
        return `$${dollars}`;
    };

    // Get med_id from selected product/variant
    const getCartItemMedId = (cartItem) => {
        if (!cartItem) return '';

        const formulaSelect = cartItem.querySelector('.cart-drawer-formula-select');
        if (!formulaSelect || !formulaSelect.value) return '';

        const selectedOption = formulaSelect.querySelector(`option[value="${formulaSelect.value}"]`);
        if (!selectedOption) return '';

        const hasVariants = selectedOption.getAttribute('data-has-variants') === 'true';

        // If product has variants, get med_id from variant
        if (hasVariants) {
            const variantSelect = cartItem.querySelector('.cart-drawer-variant-select');
            if (variantSelect && variantSelect.value) {
                const selectedVariantOption = variantSelect.querySelector(`option[value="${variantSelect.value}"]`);
                if (selectedVariantOption) {
                    const variantMed = selectedVariantOption.getAttribute('data-med');
                    if (variantMed) return variantMed;
                }
            }
        }

        // Otherwise, get med_id from product
        const productMed = selectedOption.getAttribute('data-med');
        return productMed || '';
    };

    // Update checkout URL with med_id
    const updateCheckoutUrl = () => {
        const checkoutButton = document.querySelector('[data-cart-drawer-checkout]');
        if (!checkoutButton) return;

        const cartItems = document.querySelectorAll('.custom-cart-drawer-item');
        let medIds = [];

        cartItems.forEach(cartItem => {
            const medId = getCartItemMedId(cartItem);
            if (medId) {
                medIds.push(medId);
            }
        });

        // Build URL with med parameter(s)
        const baseUrl = 'https://intake.braverx.com/flow/brave-patient-health-intake/variant/brave-internal-v1';
        if (medIds.length > 0) {
            // If multiple items, join med IDs (you can adjust this logic as needed)
            const medParam = medIds.join(',');
            checkoutButton.href = `${baseUrl}?med=${medParam}`;
        } else {
            checkoutButton.href = `${baseUrl}?med=`;
        }
    };

    // Calculate and update cart total
    const updateCartTotal = () => {
        const cartItems = document.querySelectorAll('.custom-cart-drawer-item');
        let totalCents = 0;
        let itemCount = 0;

        cartItems.forEach(cartItem => {
            const priceCents = getCartItemPrice(cartItem);
            if (priceCents > 0) {
                totalCents += priceCents;
                itemCount++;
            }
        });

        // Update subtotal
        const subtotalElement = document.querySelector('[data-cart-drawer-subtotal]');
        if (subtotalElement) {
            subtotalElement.textContent = `${formatPrice(totalCents)}/mo`;
        }

        // Update item count
        const itemCountElements = document.querySelectorAll('[data-cart-drawer-item-count]');
        itemCountElements.forEach(el => {
            el.textContent = itemCount;
        });

        // Update plural
        const pluralElements = document.querySelectorAll('[data-cart-drawer-item-count-plural]');
        pluralElements.forEach(el => {
            el.textContent = itemCount === 1 ? '' : 's';
        });
    };

    // Handle usage change - filter formula options
    document.addEventListener('change', (event) => {
        if (!event.target.classList.contains('cart-drawer-usage-select')) return;
        
        const usageSelect = event.target;
        const selectedUsage = usageSelect.value;
        const cartItem = usageSelect.closest('.custom-cart-drawer-item');
        if (!cartItem) return;
        
        const formulaSelect = cartItem.querySelector('.cart-drawer-formula-select');
        const variantSelect = cartItem.querySelector('.cart-drawer-variant-select');
        const variantContainer = cartItem.querySelector('.cart-drawer-variant-container');
        
        if (!formulaSelect) return;
        
        // Filter formula options by selected usage
        const allOptions = formulaSelect.querySelectorAll('option');
        let firstVisibleOption = null;
        
        allOptions.forEach(option => {
            const optionUsage = option.getAttribute('data-usage');
            if (optionUsage === selectedUsage) {
                option.removeAttribute('hidden');
                option.disabled = false;
                if (!firstVisibleOption) {
                    firstVisibleOption = option;
                }
            } else {
                option.setAttribute('hidden', 'hidden');
                option.disabled = true;
            }
        });
        
        // Reset formula selection to first available option for this usage
        if (firstVisibleOption) {
            formulaSelect.value = firstVisibleOption.value;

            // Directly update variants for the newly selected formula
            const selectedOption = firstVisibleOption;
            const hasVariants = selectedOption.getAttribute('data-has-variants') === 'true';

            if (variantSelect && variantContainer) {
                // Always hide all variant options first
                const allVariantOptions = variantSelect.querySelectorAll('option');
                allVariantOptions.forEach(variantOption => {
                    variantOption.setAttribute('hidden', 'hidden');
                    variantOption.disabled = true;
                });

                if (hasVariants) {
                    // Get usage and product handle
                    const selectedUsage = usageSelect.value;
                    const productHandle = firstVisibleOption.value;

                    // Update variant title
                    const variantTitle = cartItem.querySelector('[data-cart-drawer-variant-title]');
                    if (variantTitle) {
                        const variantOptionName = selectedOption.getAttribute('data-variant-option-name');
                        variantTitle.textContent = variantOptionName || 'Variant';
                    }

                    // Show/hide variant options based on selected product
                    let firstVisibleVariant = null;
                    let hasVisibleVariants = false;

                    allVariantOptions.forEach(variantOption => {
                        const variantUsage = variantOption.getAttribute('data-usage');
                        const variantProductHandle = variantOption.getAttribute('data-product-handle');

                        if (variantUsage === selectedUsage && variantProductHandle === productHandle) {
                            variantOption.removeAttribute('hidden');
                            variantOption.disabled = false;
                            hasVisibleVariants = true;
                            if (!firstVisibleVariant) {
                                firstVisibleVariant = variantOption;
                            }
                        }
                    });

                    // Show variant container if there are visible variants
                    if (hasVisibleVariants) {
                        variantContainer.style.display = '';
                        // Set first visible variant as selected
                        if (firstVisibleVariant) {
                            variantSelect.value = firstVisibleVariant.value;
                        }
                    } else {
                        variantContainer.style.display = 'none';
                    }
                } else {
                    // Hide variant container if product has no variants
                    variantContainer.style.display = 'none';
                }
            }
        } else {
            // If no options found, clear selection and hide variants
            formulaSelect.value = '';
            if (variantContainer) {
                variantContainer.style.display = 'none';
            }
            // Hide all variant options
            if (variantSelect) {
                const allVariantOptions = variantSelect.querySelectorAll('option');
                allVariantOptions.forEach(variantOption => {
                    variantOption.setAttribute('hidden', 'hidden');
                    variantOption.disabled = true;
                });
            }
        }

        // Update cart item description for the newly selected formula
        if (firstVisibleOption) {
            updateCartItemDescription(cartItem, selectedUsage, firstVisibleOption.value);
        } else {
            // Clear description if no formula selected
            const descriptionElement = cartItem.querySelector('.custom-cart-drawer-item-description');
            if (descriptionElement) {
                descriptionElement.innerHTML = '';
            }
        }

        // Update cart total
        updateCartTotal();
        updateCartEmptyState();
        updateCheckoutUrl();
    });

    // Handle variant change - update title if needed
    document.addEventListener('change', (event) => {
        if (!event.target.classList.contains('cart-drawer-variant-select')) return;

        const variantSelect = event.target;
        const selectedOption = variantSelect.options[variantSelect.selectedIndex];
        const cartItem = variantSelect.closest('.custom-cart-drawer-item');

        if (cartItem && selectedOption) {
            const variantTitle = cartItem.querySelector('[data-cart-drawer-variant-title]');
            if (variantTitle) {
                // Update title to show selected variant name or keep as "Variant"
                // variantTitle.textContent = selectedOption.textContent; // Uncomment to show variant name
            }
        }

        // Update cart total
        updateCartTotal();
        updateCartEmptyState();
        updateCheckoutUrl();
    });

    // Handle formula change - show variants if available
    document.addEventListener('change', (event) => {
        if (!event.target.classList.contains('cart-drawer-formula-select')) return;
        
        const formulaSelect = event.target;
        const selectedProductHandle = formulaSelect.value;
        const selectedOption = formulaSelect.querySelector(`option[value="${selectedProductHandle}"]`);
        const cartItem = formulaSelect.closest('.custom-cart-drawer-item');
        if (!cartItem || !selectedOption) return;
        
        const variantSelect = cartItem.querySelector('.cart-drawer-variant-select');
        const variantContainer = cartItem.querySelector('.cart-drawer-variant-container');
        const hasVariants = selectedOption.getAttribute('data-has-variants') === 'true';
        
        if (!variantSelect || !variantContainer) return;

        // Always hide all variant options first
        const allVariantOptions = variantSelect.querySelectorAll('option');
        allVariantOptions.forEach(variantOption => {
            variantOption.setAttribute('hidden', 'hidden');
            variantOption.disabled = true;
        });

        if (hasVariants) {
            // Get usage and product handle
            const usageSelect = cartItem.querySelector('.cart-drawer-usage-select');
            const selectedUsage = usageSelect ? usageSelect.value : '';
            const productHandle = selectedProductHandle;
            
            // Show variant container
            variantContainer.style.display = '';
            
            // Update variant title
            const variantTitle = cartItem.querySelector('[data-cart-drawer-variant-title]');
            if (variantTitle) {
                const variantOptionName = selectedOption.getAttribute('data-variant-option-name');
                variantTitle.textContent = variantOptionName || 'Variant';
            }
            
            // Show/hide variant options based on selected product
            let firstVisibleVariant = null;
            let hasVisibleVariants = false;

            allVariantOptions.forEach(variantOption => {
                const variantUsage = variantOption.getAttribute('data-usage');
                const variantProductHandle = variantOption.getAttribute('data-product-handle');

                if (variantUsage === selectedUsage && variantProductHandle === productHandle) {
                    variantOption.removeAttribute('hidden');
                    variantOption.disabled = false;
                    hasVisibleVariants = true;
                    if (!firstVisibleVariant) {
                        firstVisibleVariant = variantOption;
                    }
                }
            });

            // Show variant container if there are visible variants
            if (hasVisibleVariants) {
                variantContainer.style.display = '';
                // Set first visible variant as selected
                if (firstVisibleVariant) {
                    variantSelect.value = firstVisibleVariant.value;
                }
            } else {
                variantContainer.style.display = 'none';
            }
        } else {
            // Hide variant container if product has no variants
            variantContainer.style.display = 'none';
            // Hide all variant options
            const allVariantOptions = variantSelect.querySelectorAll('option');
            allVariantOptions.forEach(variantOption => {
                variantOption.setAttribute('hidden', 'hidden');
                variantOption.disabled = true;
            });
        }

        // Update cart item description
        updateCartItemDescription(cartItem, selectedUsage, selectedProductHandle);

        // Update cart total
        updateCartTotal();
        updateCartEmptyState();
        updateCheckoutUrl();
    });

    // Initialize - filter formula options based on selected usage
    document.querySelectorAll('.cart-drawer-usage-select').forEach(usageSelect => {
        const selectedUsage = usageSelect.value;
        const cartItem = usageSelect.closest('.custom-cart-drawer-item');
        if (!cartItem) return;
        
        const formulaSelect = cartItem.querySelector('.cart-drawer-formula-select');
        if (!formulaSelect) return;
        
        // Filter formula options by selected usage on page load
        const allOptions = formulaSelect.querySelectorAll('option');
        let firstVisibleOption = null;
        
        allOptions.forEach(option => {
            const optionUsage = option.getAttribute('data-usage');
            if (optionUsage === selectedUsage) {
                option.removeAttribute('hidden');
                option.disabled = false;
                if (!firstVisibleOption) {
                    firstVisibleOption = option;
                }
            } else {
                option.setAttribute('hidden', 'hidden');
                option.disabled = true;
            }
        });
        
        // Don't auto-select formula on initialization - keep cart empty by default
        // Only initialize variants if a formula is already selected
        const currentSelectedValue = formulaSelect.value;
        if (currentSelectedValue) {
            // Get the selected option
            const selectedOption = formulaSelect.querySelector(`option[value="${currentSelectedValue}"]`);
            if (selectedOption) {
                const hasVariants = selectedOption.getAttribute('data-has-variants') === 'true';
                const variantSelect = cartItem.querySelector('.cart-drawer-variant-select');
                const variantContainer = cartItem.querySelector('.cart-drawer-variant-container');

                if (variantSelect && variantContainer) {
                    // Always hide all variant options first
                    const allVariantOptions = variantSelect.querySelectorAll('option');
                    allVariantOptions.forEach(variantOption => {
                        variantOption.setAttribute('hidden', 'hidden');
                        variantOption.disabled = true;
                    });

                    if (hasVariants) {
                        // Get usage and product handle
                        const selectedUsage = usageSelect.value;
                        const productHandle = currentSelectedValue;

                        // Update variant title
                        const variantTitle = cartItem.querySelector('[data-cart-drawer-variant-title]');
                        if (variantTitle) {
                            const variantOptionName = selectedOption.getAttribute('data-variant-option-name');
                            variantTitle.textContent = variantOptionName || 'Variant';
                        }

                        // Show/hide variant options based on selected product
                        let firstVisibleVariant = null;
                        let hasVisibleVariants = false;

                        allVariantOptions.forEach(variantOption => {
                            const variantUsage = variantOption.getAttribute('data-usage');
                            const variantProductHandle = variantOption.getAttribute('data-product-handle');

                            if (variantUsage === selectedUsage && variantProductHandle === productHandle) {
                                variantOption.removeAttribute('hidden');
                                variantOption.disabled = false;
                                hasVisibleVariants = true;
                                if (!firstVisibleVariant) {
                                    firstVisibleVariant = variantOption;
                                }
                            }
                        });

                        // Show variant container if there are visible variants
                        if (hasVisibleVariants) {
                            variantContainer.style.display = '';
                            // Set first visible variant as selected
                            if (firstVisibleVariant) {
                                variantSelect.value = firstVisibleVariant.value;
                            }
                        } else {
                            variantContainer.style.display = 'none';
                        }

                        // Update product description
                        updateCartItemDescription(cartItem, selectedUsage, currentSelectedValue);
                    } else {
                        // Product has no variants, hide container
                        variantContainer.style.display = 'none';
                    }

                    // Update product description
                    updateCartItemDescription(cartItem, selectedUsage, currentSelectedValue);
                }
            }
        }
        
        // Also trigger change event as fallback
        if (formulaSelect.value) {
            formulaSelect.dispatchEvent(new Event('change'));
        }
    });

    // Cart drawer open/close functionality
    const cartDrawer = document.querySelector('[data-cart-drawer]');
    const cartDrawerOverlay = document.querySelector('.custom-cart-drawer-overlay');
    const closeButton = document.querySelector('[data-cart-drawer-close]');

    // Check if cart is empty and update class
    const updateCartEmptyState = () => {
        const cartItems = document.querySelectorAll('.custom-cart-drawer-item');
        const isEmpty = cartItems.length === 0 || Array.from(cartItems).every(item => {
            const formulaSelect = item.querySelector('.cart-drawer-formula-select');
            // Check if formula has a value AND it's not just empty string
            const hasFormula = formulaSelect && formulaSelect.value && formulaSelect.value.trim() !== '';
            return !hasFormula;
        });

        if (cartDrawer) {
            if (isEmpty) {
                cartDrawer.classList.add('custom-cart-drawer--empty');
            } else {
                cartDrawer.classList.remove('custom-cart-drawer--empty');
            }
        }
    };

    // Open cart drawer
    const openCartDrawer = () => {
        if (cartDrawer) {
            cartDrawer.classList.add('custom-cart-drawer-open');
            document.body.style.overflow = 'hidden'; // Prevent body scroll
        }
        // Overlay is handled by CSS (.custom-cart-drawer.custom-cart-drawer-open ~ .custom-cart-drawer-overlay)
    };

    // Close cart drawer
    const closeCartDrawer = () => {
        if (cartDrawer) {
            cartDrawer.classList.remove('custom-cart-drawer-open');
            document.body.style.overflow = ''; // Restore body scroll
        }
        // Overlay is handled by CSS
    };

    // Make functions globally accessible
    window.openCartDrawer = openCartDrawer;
    window.closeCartDrawer = closeCartDrawer;
    window.updateCartEmptyState = updateCartEmptyState;
    window.updateCartTotal = updateCartTotal;
    window.updateCheckoutUrl = updateCheckoutUrl;

    // Close button click handler
    if (closeButton) {
        closeButton.addEventListener('click', (e) => {
            e.preventDefault();
            closeCartDrawer();
        });
    }

    // Overlay click handler
    if (cartDrawerOverlay) {
        cartDrawerOverlay.addEventListener('click', () => {
            closeCartDrawer();
        });
    }

    // Close on Escape key press
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && cartDrawer && cartDrawer.classList.contains('custom-cart-drawer-open')) {
            closeCartDrawer();
        }
    });

    // Handle delete button click
    document.addEventListener('click', (event) => {
        if (!event.target.closest('[data-cart-drawer-item-delete]')) return;

        const deleteButton = event.target.closest('[data-cart-drawer-item-delete]');
        const cartItem = deleteButton.closest('.custom-cart-drawer-item');
        if (!cartItem) return;

        // Reset all dropdowns
        const usageSelect = cartItem.querySelector('.cart-drawer-usage-select');
        const formulaSelect = cartItem.querySelector('.cart-drawer-formula-select');
        const variantSelect = cartItem.querySelector('.cart-drawer-variant-select');
        const variantContainer = cartItem.querySelector('.cart-drawer-variant-container');
        const descriptionElement = cartItem.querySelector('.custom-cart-drawer-item-description');

        // Reset usage dropdown to first option
        if (usageSelect) {
            const firstOption = usageSelect.querySelector('option:not([hidden])');
            if (firstOption) {
                usageSelect.value = firstOption.value;
            } else {
                usageSelect.value = '';
            }
        }

        // Reset formula dropdown
        if (formulaSelect) {
            formulaSelect.value = '';
        }

        // Reset variant dropdown and hide container
        if (variantSelect) {
            variantSelect.value = '';
            // Hide all variant options
            const allVariantOptions = variantSelect.querySelectorAll('option');
            allVariantOptions.forEach(variantOption => {
                variantOption.setAttribute('hidden', 'hidden');
                variantOption.disabled = true;
            });
        }

        if (variantContainer) {
            variantContainer.style.display = 'none';
        }

        // Clear description
        if (descriptionElement) {
            descriptionElement.innerHTML = '';
        }

        // Update cart total and empty state
        updateCartTotal();
        updateCartEmptyState();
        updateCheckoutUrl();
    });

    // Handle cart icon click to open cart drawer
    document.addEventListener('click', (event) => {
        const cartTrigger = event.target.closest('[data-cart-drawer-open-trigger]');
        if (cartTrigger) {
            event.preventDefault();
            openCartDrawer();
        }
    });

    // Handle empty state "Get Started" button click - remove empty state and set default selections
    document.addEventListener('click', (event) => {
        const emptyCtaButton = event.target.closest('[data-cart-drawer-empty-cta]');
        if (emptyCtaButton && cartDrawer) {
            event.preventDefault();
            
            // Remove empty class to show cart content
            cartDrawer.classList.remove('custom-cart-drawer--empty');
            
            // Find the first cart item and set default selections
            const cartItem = cartDrawer.querySelector('.custom-cart-drawer-item');
            if (cartItem) {
                const usageSelect = cartItem.querySelector('.cart-drawer-usage-select');
                const formulaSelect = cartItem.querySelector('.cart-drawer-formula-select');
                
                if (usageSelect && formulaSelect) {
                    // Set first usage if not already selected
                    if (!usageSelect.value || usageSelect.value.trim() === '') {
                        const firstUsageOption = usageSelect.querySelector('option:not([hidden])');
                        if (firstUsageOption) {
                            usageSelect.value = firstUsageOption.value;
                            // Trigger change to filter formulas
                            usageSelect.dispatchEvent(new Event('change'));
                        }
                    }
                    
                    // Wait a bit for usage change to process, then set first formula
                    setTimeout(() => {
                        // Filter formulas for selected usage
                        const selectedUsage = usageSelect.value;
                        const allFormulaOptions = formulaSelect.querySelectorAll('option');
                        let firstVisibleFormula = null;
                        
                        allFormulaOptions.forEach(option => {
                            const optionUsage = option.getAttribute('data-usage');
                            if (optionUsage === selectedUsage) {
                                option.removeAttribute('hidden');
                                option.disabled = false;
                                if (!firstVisibleFormula) {
                                    firstVisibleFormula = option;
                                }
                            } else {
                                option.setAttribute('hidden', 'hidden');
                                option.disabled = true;
                            }
                        });
                        
                        // Set first visible formula as selected
                        if (firstVisibleFormula && (!formulaSelect.value || formulaSelect.value.trim() === '')) {
                            formulaSelect.value = firstVisibleFormula.value;
                            
                            // Get variant elements
                            const variantSelect = cartItem.querySelector('.cart-drawer-variant-select');
                            const variantContainer = cartItem.querySelector('.cart-drawer-variant-container');
                            const hasVariants = firstVisibleFormula.getAttribute('data-has-variants') === 'true';
                            
                            // Trigger change to update variants, description, totals
                            formulaSelect.dispatchEvent(new Event('change'));
                            
                            // If product has variants, ensure they're shown after a delay
                            if (hasVariants && variantSelect && variantContainer) {
                                setTimeout(() => {
                                    // Double-check variants are visible
                                    const allVariantOptions = variantSelect.querySelectorAll('option');
                                    let hasVisibleVariants = false;
                                    
                                    allVariantOptions.forEach(variantOption => {
                                        const variantUsage = variantOption.getAttribute('data-usage');
                                        const variantProductHandle = variantOption.getAttribute('data-product-handle');
                                        
                                        if (variantUsage === selectedUsage && variantProductHandle === firstVisibleFormula.value) {
                                            variantOption.removeAttribute('hidden');
                                            variantOption.disabled = false;
                                            hasVisibleVariants = true;
                                        }
                                    });
                                    
                                    if (hasVisibleVariants) {
                                        variantContainer.style.display = '';
                                        // Set first variant as selected
                                        const firstVisibleVariant = Array.from(allVariantOptions).find(opt => 
                                            !opt.hasAttribute('hidden') && 
                                            opt.getAttribute('data-usage') === selectedUsage &&
                                            opt.getAttribute('data-product-handle') === firstVisibleFormula.value
                                        );
                                        if (firstVisibleVariant) {
                                            variantSelect.value = firstVisibleVariant.value;
                                            // Trigger variant change to update totals
                                            variantSelect.dispatchEvent(new Event('change'));
                                        }
                                        
                                        // Update variant title
                                        const variantTitle = cartItem.querySelector('[data-cart-drawer-variant-title]');
                                        if (variantTitle) {
                                            const variantOptionName = firstVisibleFormula.getAttribute('data-variant-option-name');
                                            variantTitle.textContent = variantOptionName || 'Variant';
                                        }
                                        
                                        // Update cart total and checkout URL after variant is set
                                        // Use longer delay to ensure variant is fully processed
                                        setTimeout(() => {
                                            updateCartTotal();
                                            updateCheckoutUrl();
                                            updateCartEmptyState();
                                        }, 150);
                                    }
                                }, 200);
                            } else {
                                // No variants - update totals after formula is set
                                setTimeout(() => {
                                    updateCartTotal();
                                    updateCheckoutUrl();
                                    updateCartEmptyState();
                                }, 150);
                            }
                        }
                    }, 150);
                    
                    // Final update after all selections are set (extra safety)
                    setTimeout(() => {
                        updateCartTotal();
                        updateCheckoutUrl();
                        updateCartEmptyState();
                    }, 400);
                }
            }
        }
    });

    // Initialize cart total and checkout URL
    updateCartTotal();
    updateCheckoutUrl();
    
    // Always keep empty class on initial page load - cart should be empty by default
    if (cartDrawer) {
        cartDrawer.classList.add('custom-cart-drawer--empty');
    }
});
